import * as React from 'react';

import { Formatters, Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { IViewInfo } from '../../../ts/models/IViewInfo';
import { PopularExplanation, SimiliarUsersExplanation } from '../../../ts/models/IVizRecommendationInfo';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { ViewTooltip } from '../Tooltips/ViewTooltip';
import { CardTextAndLink } from './CardTextAndLink';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

export class RecommendationCard extends ContentCard {

  public render() {
    return (
      <div className={CardViewStyles.Card}>
        { this.renderRecommendationExplanation() }
        <TooltipAnchor tooltipContent={this.renderTooltipContent} width={DetailsTooltipStyles.Width} onShowTooltip={this.handleShowTooltip}
          title={Messages.viewTooltipTitle()}>
          <Thumbnail navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
                    defaultImageUrl={imgPath('spaces_card_view.svg')}
                    thumbnailImageUrl={this.props.content.thumbnailUrl}
                    hoveredOrSelected={this.props.hoveredOrSelected} />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span data-tb-test-id="view-name" className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          { this.renderViewIconForVizRec() }
          { this.renderViewsCountForVizRec() }
          <span>
            <FavoriteToggle canHaveKeyboardFocus={true}
                            isFavorite={this.props.content.favorite}
                            onAddFavorite={() => this.props.addContentFavorite(this.props.content.id, 'view')}
                            onRemoveFavorite={() => this.props.removeContentFavorite(this.props.content.id, this.props.content.id, 'view', this.props.content.name)}/>
          </span>
          { this.renderFavoritesCountForVizRec() }
          { this.renderActionsMenu() }
        </div>
        { this.renderParentWorkbookLink() }
      </div>
    );

  }

  private renderRecommendationExplanation = () => {
    let explanationShape:string = '';
    let explanationText = '';
    if (this.props.content.explanationType === PopularExplanation) {
      explanationShape = 'ribbon_Trending.svg';
      explanationText = Messages.vizRecommendationsPopularExplanation();
    } else if (this.props.content.explanationType === SimiliarUsersExplanation) {
      explanationShape = 'ribbon_ForYou.svg';
      explanationText = Messages.vizRecommendationsSimiliarUsersExplanation();
    }

    if (explanationShape && explanationText) {
      return <div data-tb-test-id="recommendation-explanation">
        <span className={CardViewStyles.RecommendationCardText}>{explanationText}</span>
        <img src = {imgPath(explanationShape)} className={CardViewStyles.RecommendationCardShape}/>
      </div>;
    }
  }

  private renderParentWorkbookLink = () => {
    const workbook = (this.props.content as IViewInfo).workbook;
    return <div className={CardViewStyles.CardDescription}>
      <CardTextAndLink
        text={''}
        url={this.props.urls.exploreWorkbookUrl(workbook.id)}
        urlDisplayName={workbook.name}
        marginLeft={-9}
      />
    </div>;
  }

  private renderTooltipContent = () => {
    return <ViewTooltip content={this.props.content}
                        urls={this.props.urls}
                        showAsRecommendation={true} />;
  }

  private renderViewIconForVizRec = () => {
    return <span className={CardViewStyles.VizRecViewsIcon}></span>;
  }

  private renderViewsCountForVizRec = () => {
    const viewsCount = (this.props.content as IViewInfo).usageInfo.hitsTotal;
    return <span className={CardViewStyles.VizRecViewsCount}>{Formatters.formatCount(viewsCount)}</span>;
  }

  private renderFavoritesCountForVizRec = () => {
    const favoritesCount = (this.props.content as IViewInfo).usageInfo.favoritesTotal;
    return <span className={CardViewStyles.VizRecFavoritesCount}>{Formatters.formatCount(favoritesCount)}</span>;
  }
}
